<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" :label-width="labelWidth">
        <!-- vin -->
        <el-form-item label="VIN:">
          <el-input
            v-model="queryParams.vin"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 品牌 -->
        <el-form-item :label="$t('home.brand') + ':'">
          <el-input
            v-model="queryParams.carBrand"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item :label="$t('home.carType') + ':'">
          <el-input
            v-model="queryParams.carModel"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 订单号 -->
        <el-form-item :label="$t('cart.orderNumber') + ':'">
          <el-input
            v-model="queryParams.orderNum"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 完成情况 -->
        <el-form-item :label="$t('upgrade.execution') + '：'">
          <el-select v-model="queryParams.completeStatus" filterable clearable>
            <el-option :value="0" :label="$t('upgrade.unfinished')"></el-option>
            <el-option :value="1" :label="$t('upgrade.finished')"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div>
          <el-button
            class="primary-btn"
            type="primary"
            @click="handleCompleted()"
          >
            <i class="el-icon-circle-check"></i>
            {{ $t("upgrade.completed") }}
          </el-button>
        </div>
        <div>
          <el-button class="primary-btn" type="primary" @click="doSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <el-table
        ref="tableRef"
        stripe
        border
        highlight-current-row
        :data="tableData"
        :max-height="maxHeight"
        @selection-change="handleSelection"
      >
        <el-table-column
          type="selection"
          width="40"
          fixed="left"
          align="center"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          :label="$t('cart.xh')"
          width="60px"
          align="center"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- VIN -->
        <el-table-column
          label="VIN"
          min-width="180"
          align="center"
          prop="vin"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 品牌 -->
        <el-table-column
          :label="$t('home.brand')"
          min-width="130"
          prop="carBrand"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 车型 -->
        <el-table-column
          :label="$t('home.carType')"
          min-width="130"
          prop="carModel"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 订单号 -->
        <el-table-column
          prop="orderNum"
          :label="$t('cart.orderNumber')"
          min-width="130"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 生产日期 -->
        <el-table-column
          prop="productionDate"
          :label="$t('seek.produceDate')"
          width="160"
          align="center"
          :render-header="$globalRenderHeader"
        ></el-table-column>
        <!-- 完成情况 -->
        <el-table-column
          :label="$t('upgrade.execution')"
          min-width="110"
          prop="completeStatus"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <span class="redColor" v-if="scope.row.completeStatus == 0">{{
              $t("upgrade.unfinished")
            }}</span>
            <span class="successColor" v-if="scope.row.completeStatus == 1">{{
              $t("upgrade.finished")
            }}</span>
          </template>
        </el-table-column>
        <!-- 附件 -->
        <el-table-column
          :label="$t('zlfk.fj')"
          min-width="240px"
          :render-header="$globalRenderHeader"
          prop="files"
        >
          <template slot-scope="scope">
            <!-- <drag-upload
              ref="uploadFile"
              :accessoryList.sync="scope.row.files"
              :httpRequest="action"
            /> -->
            <div style="display: flex; flex-wrap: wrap">
              <el-button
                class="uploadButton"
                v-if="scope.row.completeStatus == 0"
                type="text"
                @click="uploadClick(scope.row)"
              >
                <img src="@/assets/image/fileUpload.svg" alt="" />
                {{ $t("upgrade.upload") }}
              </el-button>
              <file-upload-list
                v-if="scope.row.files.length > 0"
                ref="fileUploadList"
                :fileList="scope.row.files"
              ></file-upload-list>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="total > 0"
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <upload-dialog ref="uploadDialog" @success="getList"></upload-dialog>
  </div>
</template>
<script>
import { getStorage } from "@/util/localStor";
import { getVinHandleList, getVinComplete } from "@/api/vehicleUpgrade";
import uploadDialog from "./uploadDialog.vue";
import listCurd from "@/mixins/listCurd";
export default {
  mixins: [listCurd],
  components: {
    uploadDialog,
  },
  data() {
    return {
      queryParams: {},
      maxHeight: null,
      selectionList: [],
      // tableData: [],
      listMethod: getVinHandleList, // 获取表格数据api
      type: "progressOrder",
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "80px",
        ru: "235px",
        en: "225px",
        vi: "205px",
        es: "275px",
        fa: "140px",
      };
      return widthMap[this.$i18n.locale] || "125px";
    },
  },
  created() {
    this.removeItem("progressOrder");
    var list = getStorage("upgradeData");
    this.queryParams.upgradeOrderNum = list.upgradeOrderNum;
    // 获取表格数据
    this.getList();
  },
  methods: {
    // 参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 多选
    handleSelection(val) {
      this.selectionList = val;
    },
    // 完成
    async handleCompleted() {
      const id = this.selectionList.map((item) => item.id);
      const res = await getVinComplete({
        data: {
          ids: id,
        },
      });
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
      } else {
        this.$DonMessage.error(res.message);
      }
    },
    // 上传
    uploadClick(data) {
      var type = "jpg, png, jpeg, svg, mp4, 3gp, mov, m4v";
      var tips = `<p>${this.$t("zlfk.tpzc")}</p><p>${this.$t("zlfk.spzc")}</p>`;
      var filePath = "/customer/claim/upload";
      this.$refs.uploadDialog.init(
        data,
        this.$t("upgrade.upload"),
        type,
        tips,
        filePath
      );
    },
  },
};
</script>
<style>
.el-button.uploadButton,
.el-button.uploadButton span {
  display: flex;
  align-items: center;
}
.el-button.uploadButton img {
  width: 18px;
  margin: 0 2px;
}
</style>
